export default "__VITE_ASSET__625c8e57__"